import r, { createContext as l, useContext as d } from "react";
var o = l(null);
o.displayName = "OpenClosedContext";

var p = function (e) {
  return e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e;
}(p || {});

function s() {
  return d(o);
}

function C(_ref) {
  var t = _ref.value,
      n = _ref.children;
  return r.createElement(o.Provider, {
    value: t
  }, n);
}

export { C as OpenClosedProvider, p as State, s as useOpenClosed };